module.exports = __webpack_public_path__ + "img/2.4dbd8713.webp";